// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-large-viewport":"(min-width: 1024px)","container":"error-page_container__oAEzG","content":"error-page_content___0vgQ","error":"error-page_error__ayTb_"};